import { Model } from '@/models/Model';
export class LessonType extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'LessonType';
        this.$endpoint = '/lesson-types';
        this.$fillable = ['name', 'icon'];
    }
}
